// extracted by mini-css-extract-plugin
export var addToCartButton = "_qc-b";
export var arrowButtonContainer = "_qc-9";
export var arrowButtonIcon = "_qc-a";
export var carouselArrowButton = "_qc-6";
export var carouselElementContainer = "_qc-1";
export var left = "_qc-7";
export var productDisplayCarouselContainer = "_qc-0";
export var productTileContainer = "_qc-2";
export var productTileImage = "_qc-4";
export var productTileImageContainer = "_qc-3";
export var productTileTitle = "_qc-5";
export var right = "_qc-8";
export var sliderOverflow = "_qc-c";